import type { DocPageContent } from '../docs-content'

const page = {
  order: 1,
  slug: 'getting-started',
  title: '快速开始',
  description: '从首次启动到首次导出。',
  category: '开始',
  sections: [
    {
      title: '本页内容',
      items: [
        '剪见 JIAN 是什么：一款本地优先、基于浏览器的视频编辑器。',
        '为什么项目和媒体保存在本地而非上传。',
        '推荐使用的浏览器以及 Chromium 支持的重要性。',
      ],
    },
    {
      title: '首次编辑流程',
      items: [
        '在支持的浏览器中打开剪见 JIAN。',
        '选择一个具有读写权限的工作区文件夹。',
        '创建项目并选择项目的分辨率和帧率。',
        '将媒体导入媒体面板。',
        '将媒体拖入时间线并按空格键预览。',
        '保存项目并导出首个视频。',
      ],
    },
    {
      title: '首次运行检查',
      items: [
        '确认工作区选择器可以打开。',
        '确认导入的媒体出现在媒体面板中。',
        '确认可以从时间线开始播放。',
        '确认导出可以打开且预检未显示阻塞性问题。',
      ],
    },
  ],
} satisfies DocPageContent

export default page
